/**
 * @module contactType
 * @description A list of contactType
 */
export const contactType = [
	'employee',
	'supplier',
	'customer',
	'user',
] as const;
export type ContactType = (typeof contactType)[number];
